export const DEV = false;

// New Store Script => Saved for revision before adding to the map
export const NEW_STORE_SHEETS ="https://script.google.com/macros/s/AKfycbyhEjVuk7yumw1TeiTL0GGRxXO8-zNmhWHNRYGfnwL4G5zONe8P1kqV58pmPseivfzH/exec";

// Diferent Sheets for marker fetching
export const SHEETS_INFO_TEAMS = {
  bcharg: {
    url: "167aW-yDKRoG4zzQy8D5t9I6ZAjQCeBvFntum6pZcis0",
    name: "Hoja 1",
    update: "https://script.google.com/macros/s/AKfycbwDPvsDdeCTh3bJOzU84irYVahZD2EhD7JtZr7Lgrr1Ouie0P-it9oLUbwksB1N_6Q9/exec",
  },
paytaca: {
    url: "1HyiuZiIZq2N3zC_IH0I0l1Cfolju5Lo5Xmr_oxh5g_c",
    name: "Sheet1",
    update: "https://script.google.com/macros/s/AKfycbw-mHeZEKleUqLZicSU4fCeqKI1j6DIlZRpgzGv3wl7z8vKKv4jc5yfXQIPG71mFdwD/exec",
  }
};

// Store all forms entries, this data is not shown
export const SHEETS_LOG_HISTORY_FORMS = "https://script.google.com/macros/s/AKfycbyA7lu6-nNFgm2u0_xosONnxaxZfB64W2by0IYz1P6aYN3aSi0idN-phHeVBzrP2OEN2A/exec"

export const NEW_STORE_FORM = "https://sumate.bcharg.com/";
export const BITCOINCASH_URL = "https://bitcoincashargentina.com/";
export const BITCOINCASH_TWITTER = "https://x.com/BCHArgentina";
export const NUMERO_REPORTE = 5491164565921;
export const MENSAJE_REPORTE = `Hola buenos días. %0aLes escribo porque encontré un problema con la siguiente tienda`; // El salto de linea es %0a => Hola %0aSoy un salto de linea
export const LANGUAGES = {
  Español: "es",
  English: "en",
  Deutsch: "de",
  Filipino: "fil",  Português: "pt",
  Français: "fr",
  简体中文: "zh-CN",
  日本語: "ja",
};

export const CATEGORY_BY_LABEL = {
  // Travel / Tourism
  "viaje y turismo": 0,
  turismo: 0,
  "travel and tourism": 0,
  tourism: 0,

  // Clothing / Apparel
  "ropa, calzado y accesorios": 1,
  "ropa y accesorios": 1,
  "ropa y calzado": 1,
  "clothing and accessories": 1,
  "clothing footwear and accessories": 1,

  // Digital Consulting
  "asesoria digital": 2,
  "consultoria digital": 2,
  "digital consulting": 2,
  digital_consulting: 2,

  // Services
  servicios: 3,
  services: 3,

  // Food and Beverages
  "alimentos y bebidas": 4,
  "comida y bebidas": 4,
  "food and beverages": 4,
  food_and_beverages: 4,

  // Home Appliances
  electrohogar: 5,
  electrodomesticos: 5,
  "home appliances": 5,
  home_appliancse: 5,

  // Gastronomy
  gastronomia: 6,
  restaurant: 6,
  restaurants: 6,
  gastronomy: 6,

  // Hobbies
  hobbies: 7,
  pasatiempos: 7,

  // Hygiene and Beauty
  "higiene y belleza": 8,
  "belleza y cuidado personal": 8,
  "hygiene and beauty": 8,
  "beauty and personal care": 8,
  hygiene_and_beauty: 8,

  // Toys and Books
  "juguetes y librerias": 9,
  "juguetes y libros": 9,
  "toy stores and bookstores": 9,
  "toys and books": 9,
  toys_and_books: 9,

  // Garden and Gifts
  "vivero y regalos": 10,
  "jardin y regalos": 10,
  "garden and gifts": 10,
  garden_and_gifts: 10,

  // Apparel and Footwear (generic)
  indumentaria: 11,
  "apparel and footwear": 11,
  apparel_and_footwear: 11,

  // Transport and Customs
  "transporte y aduana": 12,
  "logistica y aduana": 12,
  "transport and customs": 12,
  transport_and_customs: 12,

  // Office Supplies
  "articulos de oficina": 13,
  "insumos de oficina": 13,
  "office supplies": 13,
  office_supplies: 13,

  // Computing / IT
  computacion: 14,
  computadoras: 14,
  informatica: 14,
  computers: 14,
  computing: 14,
  computer: 14,
  it: 14,

  // Other
  otros: 15,
  otro: 15,
  other: 15,
};

export const CATEGORY_IDS = {
  TOURISM: 0,
  CLOTHING: 1,
  DIGITAL_CONSULTING: 2,
  SERVICES: 3,
  FOOD_AND_BEVERAGES: 4,
  HOME_APPLIANCES: 5,
  GASTRONOMY: 6,
  HOBBIES: 7,
  HYGIENE_AND_BEAUTY: 8,
  TOYS_AND_BOOKS: 9,
  GARDEN_AND_GIFTS: 10,
  APPAREL_AND_FOOTWEAR: 11,
  TRANSPORT_AND_CUSTOMS: 12,
  OFFICE_SUPPLIES: 13,
  COMPUTING: 14,
  OTHER: 15,
};

export const SERVICE_TYPES = Object.freeze({
  DIGITAL: "DIGITAL",
  LOCAL: "LOCAL",
  PHYSICAL: "PHYSICAL",
});

export const SERVICE_COLORS = {
  DIGITAL: "#F59E0B",
  LOCAL: "#9747FF",
  PHYSICAL: "#2563EB",
  ALL: "#22c55e",
};

export const SERVICE_TYPE_CONFIG = {
  [SERVICE_TYPES.DIGITAL]: {
    color: "text-orange-400",
    label: "digitalService",
  },
  [SERVICE_TYPES.LOCAL]: {
    color: "text-violet-400",
    label: "localStore",
  },
  [SERVICE_TYPES.PHYSICAL]: {
    color: "text-blue-400",
    label: "physicalService",
  },
};
